import RegistreConfig from './_config/registres.routes';
import RegistresRoutes from './_config/registres.config';
import RegistresService from './services/registres.service';

// Components

import TexsComponent from './components/registres/texs';
import texsInGrid from './components/registres/texs/components/texs-in-grid';
import texsOutGrid from './components/registres/texs/components/texs-out-grid';
import dapGeoLocFixCallback from './components/dap-geo-loc-fix-callback';

import RepComponent from './components/registres/rep';
import DdndComponent from './components/registres/ddnd';
import DAPsService from '../dap/services/daps.service';

const RegistresModule = 'app.massia.gestion.registres';
angular
	.module(RegistresModule, [])
	.config(RegistreConfig)
	.config(RegistresRoutes)
	.component('texs', TexsComponent)
	.component('texsInGrid', texsInGrid)
	.component('texsOutGrid', texsOutGrid)
	.component('ddnd', DdndComponent)
	.component('rep', RepComponent)
	.component('dapGeoLocFixCallback', dapGeoLocFixCallback)
	.service('registresService', RegistresService)
	.service('dapService', DAPsService);

export default RegistresModule;
